import EmptyState from '@components/EmptyState'
import { ProgramStudentInfo } from '@interfaces/Student'
import React from 'react'

const NonLeadGroupMember: React.FC<ProgramStudentInfo> = ({ IsPrivate }) => (
  <EmptyState
    heading={
      IsPrivate
        ? 'You are enrolled in a group, your lessons are scheduled by the lead student.'
        : 'You are enrolled in a group, your lessons are scheduled by your learning center.'
    }
    img="/images/group.svg"
    linkUrl="/scheduling/my-calendar"
    btnTxt="Go to My calendar"
    top="md"
  />
)
export default NonLeadGroupMember
